// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hLjfvIEdK_USrdXzphqO {
  height: calc(100vh - 154px);
  padding: 20px 40px;
  overflow: auto;
  display: flex;
  flex-direction: row;
  gap: 40px;
}

.zd44HCYhosQJDYeTUHqs {
  overflow-y: auto;
}

.Qm6_X8tJ0ekYh48rvJ11 {
  position: absolute;
  top: 0px;
  display: flex;
  align-items: center;
}

.zfi_wkRDCiZe2rDMZ6zk {
  height: calc(100vh - 125px);
  overflow-y: auto;
  margin: 0px 20px 0 80px;
}

.jLC5pOMQ_dLGBelUniV_ {
  text-align: left;
  margin-left: 10px;
  margin-top: 15px;
}

.rvztifINp_Sa4hbQKufA {
  font-weight: 500;
}

.DC7CKvEdp6fqm0SgHIOx {
  min-height: 300px;
  overflow: auto;
  width: 50%;
  text-align: justify;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 1px #969696;
}

._n9cM6hXSlkAy3fIc8uz {
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  align-items: center;
}

.DC7CKvEdp6fqm0SgHIOx h3 {
  margin-left: 20px;
  padding-top: 15px;
}

.J1iOPvlc3EOfpCRV0Nxo {
  box-shadow: 0px 1px 2px 1px #969696;
  width: 50%;
  min-height: 300px;
  background-color: white;
  border-radius: 10px;
  overflow-y: auto;
  max-height: 100%;
  height: 100%;
  text-align: justify;
  padding: 10px;
}

.fAb4XCbUFbzrymZKj688 {
  position: relative;
  padding-bottom: 10px;
  margin-left: 10px;
}

.tmTgsn6L34UGINDvwINk h1 {
  overflow-y: auto;
  float: left;
  position: fixed;
  background-color: white;
  display: flex;
  padding-bottom: 0px;
  padding-right: 100%;
}

.fAb4XCbUFbzrymZKj688 span {
  position: absolute;
  left: 50%;
  font-weight: 600;
}

.zd44HCYhosQJDYeTUHqs {
  padding-bottom: 30px;
}

.fAb4XCbUFbzrymZKj688 {
  margin-left: 10px;
  padding-top: 15px;
}

.hBAP9bsEsGucLLcNVLro {
  padding: 13px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
}

.hBAP9bsEsGucLLcNVLro label {
  min-width: 80px;
}

.hBAP9bsEsGucLLcNVLro span {
  font-weight: bold;
}

@media only screen and (max-width: 778px) {
  .hLjfvIEdK_USrdXzphqO {
    margin: 0px 0px 0 0px;
    flex-wrap: wrap;
  }
  .zfi_wkRDCiZe2rDMZ6zk {
    margin: 0px 0px 0 0px;
  }
  .DC7CKvEdp6fqm0SgHIOx {
    width: 100%;
  }
  .J1iOPvlc3EOfpCRV0Nxo {
    width: 100%;
    margin-top: 10px;
  }
  .fAb4XCbUFbzrymZKj688 {
    font-size: 13px;
  }
  .hBAP9bsEsGucLLcNVLro {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./components/Insidedetails/Servicedetails.module.css"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,2BAAA;EACA,gBAAA;EACA,uBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAGF;;AADA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,iBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,mCAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAKF;;AAFA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AAKF;;AAFA;EACE,oBAAA;AAKF;;AAFA;EACE,iBAAA;EACA,iBAAA;AAKF;;AAHA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAMF;;AAJA;EACE,eAAA;AAOF;;AALA;EACE,iBAAA;AAQF;;AANA;EACE;IACE,qBAAA;IACA,eAAA;EASF;EAPA;IACE,qBAAA;EASF;EANA;IACE,WAAA;EAQF;EANA;IACE,WAAA;IACA,gBAAA;EAQF;EANA;IACE,eAAA;EAQF;EANA;IACE,eAAA;EAQF;AACF","sourcesContent":[".alerts {\n  height: calc(100vh - 154px);\n  padding: 20px 40px;\n  overflow: auto;\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n}\n\n.scrollclass {\n  overflow-y: auto;\n}\n.action {\n  position: absolute;\n  top: 0px;\n  display: flex;\n  align-items: center;\n}\n.noti {\n  height: calc(100vh - 125px);\n  overflow-y: auto;\n  margin: 0px 20px 0 80px;\n}\n\n.alert {\n  text-align: left;\n  margin-left: 10px;\n  margin-top: 15px;\n}\n\n.alertMsg {\n  font-weight: 500;\n}\n\n.leftDiv {\n  min-height: 300px;\n  overflow: auto;\n  width: 50%;\n  text-align: justify;\n  background-color: white;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0px 1px 2px 1px #969696;\n}\n.addaction {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  align-items: center;\n}\n.leftDiv h3 {\n  margin-left: 20px;\n  padding-top: 15px;\n}\n\n.rightDiv {\n  box-shadow: 0px 1px 2px 1px #969696;\n  width: 50%;\n  min-height: 300px;\n  background-color: white;\n  border-radius: 10px;\n  overflow-y: auto;\n  max-height: 100%;\n  height: 100%;\n  text-align: justify;\n  padding: 10px;\n}\n\n.common {\n  position: relative;\n  padding-bottom: 10px;\n  margin-left: 10px;\n}\n\n.notifications h1 {\n  overflow-y: auto;\n  float: left;\n  position: fixed;\n  background-color: white;\n  display: flex;\n  padding-bottom: 0px;\n  padding-right: 100%;\n}\n\n.common span {\n  position: absolute;\n  left: 50%;\n  font-weight: 600;\n}\n\n.scrollclass {\n  padding-bottom: 30px;\n}\n\n.common {\n  margin-left: 10px;\n  padding-top: 15px;\n}\n.commonright {\n  padding: 13px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 10px;\n}\n.commonright label {\n  min-width: 80px;\n}\n.commonright span {\n  font-weight: bold;\n}\n@media only screen and (max-width: 778px) {\n  .alerts {\n    margin: 0px 0px 0 0px;\n    flex-wrap: wrap;\n  }\n  .noti {\n    margin: 0px 0px 0 0px;\n  }\n\n  .leftDiv {\n    width: 100%;\n  }\n  .rightDiv {\n    width: 100%;\n    margin-top: 10px;\n  }\n  .common {\n    font-size: 13px;\n  }\n  .commonright {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alerts": `hLjfvIEdK_USrdXzphqO`,
	"scrollclass": `zd44HCYhosQJDYeTUHqs`,
	"action": `Qm6_X8tJ0ekYh48rvJ11`,
	"noti": `zfi_wkRDCiZe2rDMZ6zk`,
	"alert": `jLC5pOMQ_dLGBelUniV_`,
	"alertMsg": `rvztifINp_Sa4hbQKufA`,
	"leftDiv": `DC7CKvEdp6fqm0SgHIOx`,
	"addaction": `_n9cM6hXSlkAy3fIc8uz`,
	"rightDiv": `J1iOPvlc3EOfpCRV0Nxo`,
	"common": `fAb4XCbUFbzrymZKj688`,
	"notifications": `tmTgsn6L34UGINDvwINk`,
	"commonright": `hBAP9bsEsGucLLcNVLro`
};
export default ___CSS_LOADER_EXPORT___;
